import { Component, Input, inject } from '@angular/core';
import { FormGroup, ControlContainer, FormGroupDirective } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { shouldShowNitrogenCalculationToggles } from 'src/app/advice/store/selectors';
import { NitrogenCalculationSettingToggles } from 'src/app/shared/models';

@Component({
  selector: 'app-nitrogen-calculation-settings',
  templateUrl: './nitrogen-calculation-settings.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  standalone: false,
})
export class NitrogenCalculationSettingsComponent {
  parentFormGroup = inject(FormGroupDirective);
  private readonly store = inject(Store);

  @Input() nitrogenCalculationSettingsFormGroup: FormGroup;
  @Input() nitrogenCalculationSettingToggles: NitrogenCalculationSettingToggles;
  @Input() hideLabel: boolean;
  shouldShowToggles$ = this.store.pipe(select(shouldShowNitrogenCalculationToggles));
}
